var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6364 13H12.3636C11.0518 13 10 13.9889 10 15.2222V28.5556C10 29.7778 11.0518 30.7778 12.3636 30.7778H18.2727V33H27.7273V30.7778H33.6364C34.9364 30.7778 35.9882 29.7778 35.9882 28.5556L36 15.2222C36 13.9889 34.9364 13 33.6364 13ZM33.6364 28.5556H12.3636V15.2222H33.6364V28.5556ZM27.7273 21.8889L19.4545 26.3333V17.4444L27.7273 21.8889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.032768f6544333e9eb96791febe78ca0.svg";
export { ForwardRef as ReactComponent };